var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('tbody',_vm._l((_vm.rows),function(row,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n        "+_vm._s(row.unit_number)+",\n        "+_vm._s(row.category)+",\n        "+_vm._s(row.slug)+",\n        "+_vm._s(row.area)+"\n      ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }